import { useTranslation } from "@sagot/i18n";
import { Segmented } from "@sagot/ui";
import type { LeadsView } from "./lead-types";

interface LeadsViewSwitchProps {
  value: LeadsView;
  onValueChange: (view: LeadsView) => void;
}

/** Table / Board / Bookings switch shared by every view of the Leads card. */
export function LeadsViewSwitch({ value, onValueChange }: LeadsViewSwitchProps) {
  const { t } = useTranslation();
  return (
    <Segmented<LeadsView>
      aria-label={t("engage.leads.view.label")}
      value={value}
      onValueChange={onValueChange}
      options={[
        { value: "table", label: t("engage.leads.view.table") },
        { value: "board", label: t("engage.leads.view.board") },
        { value: "bookings", label: t("engage.leads.view.bookings") },
      ]}
    />
  );
}
